import React, {PureComponent} from 'react';

import {Form} from 'semantic-ui-react'

export class SceneNoiseForm extends PureComponent {
    render() {
        const {
            loading,
            onRefreshSeed,
            onSubmit,
            onUpdateParam,
            onUpdateSeed,
            params,
            seed
        } = this.props;
        return <Form className="SceneNoiseForm" disabled={loading} onSubmit={onSubmit}>
            <Form.Group widths="two">
                <Form.Input
                    label="Points"
                    max="512"
                    min="16"
                    onChange={(e, data) => onUpdateParam('npoints', data.value)}
                    step="1"
                    type="number"
                    value={params.npoints}/>
                <Form.Input
                    action={{
                        icon: "refresh",
                        onClick: (e) => {
                            e.preventDefault();
                            onRefreshSeed();
                        }
                    }}
                    label="Seed"
                    max={2 ** 32 - 1}
                    min="0"
                    onChange={(e, data) => onUpdateSeed(data.value)}
                    step="1"
                    type="number"
                    value={seed}/>
            </Form.Group>
            <Form.Group widths="three">
                <Form.Input
                    label="Lacunarity"
                    min="0.0"
                    onChange={(e, data) => onUpdateParam('lacunarity', data.value)}
                    step="0.1"
                    type="number"
                    value={parseFloat(params.lacunarity)}/>
                <Form.Input
                    label="Octaves"
                    min="1"
                    onChange={(e, data) => onUpdateParam('octaves', data.value)}
                    step="1"
                    type="number"
                    value={params.octaves}/>
                <Form.Input
                    label="Persistence"
                    min="0.0"
                    onChange={(e, data) => onUpdateParam('persistence', data.value)}
                    step="0.1"
                    type="number"
                    value={params.persistence}/>
            </Form.Group>
            <Form.Group>
                <Form.Button content="Update"/>
            </Form.Group>
        </Form>;
    }
}

export class SceneSphereForm extends PureComponent {
    render() {
        const {elevation, onUpdateElevation, onUpdateRadius, radius} = this.props;
        return <Form className="SceneSphereForm">
            <Form.Group widths="two" unstackable={true}>
                <Form.Input
                    label={`Radius (${radius})`}
                    max="72"
                    min="24"
                    onChange={(e, data) => onUpdateRadius(data.value)}
                    step="1"
                    type="range"
                    value={radius}/>
                <Form.Input
                    label={`Elevation (${elevation})`}
                    max="16"
                    min="0"
                    onChange={(e, data) => onUpdateElevation(data.value)}
                    step="1"
                    type="range"
                    value={elevation}/>
            </Form.Group>
        </Form>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/Forms.js